module.exports = __webpack_public_path__ + "img/54.28fa30de.jpg";